<script setup lang="tsx">
import HeaderComponent from '../shared/HeaderComponent.vue'
import JournalFilters from './JournalFilters.vue'
import JournalTable from './JournalTable.vue'
</script>

<template>
	<HeaderComponent :title="$t('journal.label', 2)">
		<template #right-side> </template>
	</HeaderComponent>

	<JournalFilters />
	<JournalTable />
</template>

<style lang="sass" scoped></style>
